import type { DeviceStatus, StatusCounts } from '@iot-dashboard/shared';
import { DEVICE_STATUSES, STATUS_LABELS } from '@iot-dashboard/shared';
import { toneFor } from './StatusDot';

interface Props {
  counts: StatusCounts;
  active?: DeviceStatus | '';
  onSelect?: (status: DeviceStatus | '') => void;
}

/** The Meraki-style "Online 12 · Alerting 1 · Offline 2 · Dormant 0" strip. */
export function StatusSummary({ counts, active = '', onSelect }: Props) {
  return (
    <div className="summary" role={onSelect ? 'tablist' : undefined}>
      {DEVICE_STATUSES.map((s) => (
        <button
          key={s}
          type="button"
          className={`summary__item${active === s ? ' summary__item--active' : ''}`}
          onClick={() => onSelect?.(active === s ? '' : s)}
          disabled={!onSelect}
          aria-pressed={onSelect ? active === s : undefined}
        >
          <span className={`dot dot--${toneFor(s)}`} aria-hidden="true" />
          <span className="summary__count">{counts[s]}</span>
          <span>{STATUS_LABELS[s]}</span>
        </button>
      ))}
    </div>
  );
}
